import { render, staticRenderFns } from "./ServiceListMobile.vue?vue&type=template&id=3ba29242&scoped=true&"
import script from "./ServiceListMobile.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ServiceListMobile.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ServiceListMobile.vue?vue&type=style&index=0&id=3ba29242&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba29242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ba29242')) {
      api.createRecord('3ba29242', component.options)
    } else {
      api.reload('3ba29242', component.options)
    }
    module.hot.accept("./ServiceListMobile.vue?vue&type=template&id=3ba29242&scoped=true&", function () {
      api.rerender('3ba29242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/services/index/components/ServiceListMobile.vue"
export default component.exports